<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="cargonizer_printer_id" [ttModel]="edit.cargonizer_printer_id" ttReadonly></tt-input>
        <tt-input ttLabel="cargonizer_name" [ttModel]="edit.cargonizer_name" ttReadonly></tt-input>
        <tt-input ttLabel="printer_name" [(ttModel)]="edit.name"></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
